export class Message {
    public clientuniqueid:string;
    public type:string;
    public message:string ;
    public date:Date;
    public userId:string ;
    public tenantId:string ;
    public userName:string ;
    public chatType:string ;
}
 
 
 export class chatMessage {
    public clientuniqueid:string;
    public type:string;
    public text:string ;
    public date:Date;
    public userId:any;
    public senderId?:string ;
    public avatar?:string ;
    public receiverId?:string ;
    public tenantId:string ;
    public branchId?:string ;
    public userName:string ;
    public chatType:string ;
    public files?:any;
    public reply?:any;
    public sender?:any; 
    public message?:any;
}